<template>
    <transition name="modal">
        <div v-if="open" class="m-mask" :class="{ hiden: !open }">
            <div class="m-wrapper">
                <div class="m-background" :class="[{ 'm-wide': props.wide }, getClass(props.icon) + '-border']">
                    <Card :class="getContainerClass()"
                    :style="props.wide ? { height: '100%', display: 'flex', flexDirection: 'column' } : {}"
                        :pt="{
                            header: {
                                class: 'px-3 py-2'
                            },
                            body:{
                                class: 'px-3 py-2 h-100',
                                style: props.wide ? {
                                     display: 'flex', flexDirection: 'column', overflowY: 'auto' } : {}
                            },
                            content: {
                                class: 'mb px-3 py-2',
                                style: props.wide ? { overflowY: 'auto', minHeight: '32vh' } : {}
                            },
                            footer: {
                                class: 'px-3 py-2, my-2'
                            }
                        }"
                    >
                        <template #header>
                            <div v-if="!props.noHeader" class="mb m-header">
                                <div>
                                    <img v-if="props.icon" class="m-icon" :class="getClass(props.icon)"
                                        :src="getIcon(props.icon)" />
                                </div>
                                <h3>
                                    {{ props.title }}
                                </h3>
                            </div>
                        </template>
                        <template #content>
                            <div v-if="props.text" class="m m-body m-b">
                                <p class="m-text">
                                    {{ props.text }}
                                </p>
                            </div>
                            <component class="m m-body" v-if="props.view" :is="props.view" :props="props.props">
                            </component>
                            <div v-if="props.body" :class="props.bodyClasses ? props.bodyClasses : 'm mb m-body m-b'">
                                <div v-html="props.body" class="m-text" />
                            </div>
                        </template>
                        <template #footer>

                            <div class="m m-actions" v-if="showActions">
                                <Button v-if="props.showCancelButton" id="m-cancel-button"
                                    class="m m-button m-button-cancel w-auto"
                                    style="background: cancelButtonColor"
                                    @click="async (e) => await closeModal(false, e)">
                                    {{ props.cancelButtonText }}
                                </Button>
                                <Button v-if="props.showConfirmButton" id="m-confirm-button"
                                    class="m m-button m-button-confirm w-auto"
                                    :class="{ 'btn-action': props.confirmButtonColor ? false : true }"
                                    :style="{ background: props.confirmButtonColor }"
                                    @click="async (e) => (props.awaiting ? null : await closeModal(true, e))">
                                    {{ props.awaiting ? '' : props.confirmButtonText }}
                                    <i v-if="props.awaiting" class="gg-spinner-alt" />
                                </Button>
                                <Button v-if="props.showCustomButton" id="m-confirm-button"
                                    class="m m-button btn w-auto"
                                    :class="{ 'btn-action': props.customButtonColor ? false : true }" @click="async (e) => {
                                            props.customButtonAction()
                                            await closeModal(false, e)
                                        }
                                        ">
                                    {{ props.customButtonText }}
                                </Button>
                            </div>
                            <div v-if="props.footer" class="m m-footer">
                                {{ props.footer }}
                            </div>
                        </template>
                    </Card>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
/* eslint-disable */
import { reactive, markRaw } from 'vue'
import { storeToRefs } from 'pinia'
import { useModal } from '@/stores/modal'
import warning from '@/assets/icons/warning.svg'
import done from '@/assets/icons/done.svg'
import info from '@/assets/icons/info.svg'

export default {
    name: 'XModal',

    setup() {
        const modal = useModal()
        const { open, props } = storeToRefs(modal)
        const model = reactive({
            props: props.props,
        })
        return { modal, model, open, close, props }
    },
    computed: {
        showActions() {
            return this.props.showCancelButton || this.props.showConfirmButton || this.props.showCustomButton
        }
    },

    methods: {
        async closeModal(answer) {
            await this.modal.close(answer)
        },
        getContainerClass() {
            switch (true) {
                case this.props.text && !this.props.body ? true : false:
                case !this.props.text && this.props.body ? true : false:
                    return 'm-container-simple'
                case this.props.text && this.props.body ? true : false:
                case this.props.text && this.props.view ? true : false:
                    return 'm-container-full'

                default:
                    break
            }
        },
        getIcon(icon) {
            let ico = null
            switch (icon) {
                case 'warning':
                case 'danger':
                case 'error':
                    ico = warning
                    return ico
                case 'success':
                    ico = done
                    return ico
                case 'info':
                    ico = info
                    return ico
                default:
                    break
            }
        },
        getClass(icon) {
            switch (icon) {
                case 'info':
                    return 'info'
                case 'warning':
                    return 'warning'
                case 'danger':
                case 'error':
                    return 'danger'
                case 'success':
                    return 'success'
                default:
                    break
            }
        },
    },
}
</script>
<style>
.mb {
    border-bottom: 1px solid #dee2e6;
}
</style>
<style scoped src="./Modal.scss" lang="scss" />
